module.exports = __webpack_public_path__ + "img/MailChimp.68790926.svg";